import useSWR from "swr";

import { getLayout } from "../apis/get-layout";
import { Labels } from "../models/labels";
import { useLocale } from "./use-locale";

const EMPTY_TRANSLATIONS = {} as Labels;

export const useLayout = () => {
  const { locale } = useLocale();
  const { data: layout, error, mutate } = useSWR("layout", getLayout);

  return {
    loading: !layout && !error,
    layout,
    error,
    translations: layout?.translations ?? EMPTY_TRANSLATIONS,
    mutate
  };
};
